export default __webpack_public_path__ + "static/media/flour.8406d67b.PNG";